import { useEffect, useMemo, useState } from 'react';
import { Alert, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { LayoutBaseDePagina } from '../../../shared/layouts';
import * as React from 'react';
import dayjs from 'dayjs';
import { FerramentasDaListagemPeriodo } from '../../../shared/components/ferramentas-da-listagem/FerramentasDaListagemProducaoresumo';
import { IListagemProducaoresumo, ProducaoresumoServer } from '../../../shared/services/api/rh/colaborador/Producaoresumo';
import NavTabs from './NavTabs';
dayjs.locale('pt-br');

export const ListagemProdutividadeResuno: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [rows, setRows] = useState<IListagemProducaoresumo[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const idfun = new URLSearchParams(location.search).get('idfun');
  const [vtotal, setVtotal] = useState('');

  const busca = useMemo(() => {
    return searchParams.get('busca') || `${dayjs().format('MMMM')}/${dayjs().year()}`;
  }, [searchParams]);

  useEffect(() => {
    setIsLoading(true);
    ProducaoresumoServer.getAll(idFun, busca)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) { 
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          const Tvalor = result.data.reduce((acc, item) => acc + item.total, 0);
          setVtotal(Tvalor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
          setRows(result.data);
        }
      });
  }, [busca]);
 
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') { 
      return;
    }
    setOpenmsg(false);
  };

  const idFun = useMemo(() => {
    return searchParams.get('idfun') || '';
  }, [searchParams]);

  return (
    <LayoutBaseDePagina
      titulo='Listagem de Ponto Mensal'
      barraDeFerramentas={
        <FerramentasDaListagemPeriodo
          mostrarInputBusca
          textoDaBusca={busca}
          valortotal={vtotal} 
          aoMudarTextoDeBusca={texto => setSearchParams({idfun: idFun, busca: texto }, { replace: true })}
        />
      }
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <NavTabs
          id={idfun!}
          case={5}
        />
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Data Lançamento</TableCell>
              <TableCell>Descrição</TableCell>
              <TableCell>Pivot</TableCell>
              <TableCell align='right'>Valor Atividade</TableCell>
              <TableCell align='right'>Valor Adicional</TableCell>
              <TableCell align='right'>Quantidade</TableCell>
              <TableCell align='right'>Meta</TableCell>
              <TableCell align='right'>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow
                key={row.idfun}
                hover
                sx={{ cursor: 'pointer' }}
              >
                <TableCell>{dayjs(row.datalan).format('DD/MM/YYYY')}</TableCell>
                <TableCell>{row.descricao}</TableCell>
                <TableCell>{row.pivot}</TableCell>
                <TableCell align='right'>{row.vlatividade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell align='right'>{row.vladicional.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell align='right'>{row.qtd.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell align='right'>{row.meta.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell align='right'>{row.total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3}>
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
    </LayoutBaseDePagina>
  );
};